import type { Router } from '@angular/router';
import type { TranslocoService } from '@jsverse/transloco';
import type { SearchSource } from '@presencelearning/ui/command-palette';
import { of } from 'rxjs';

const PAGES = [
  { labelKey: 'nav.home', path: '/' },
  { labelKey: 'nav.about', path: '/about' },
];

export function createPagesSearchSource(router: Router, transloco: TranslocoService): SearchSource {
  return {
    id: 'pages',
    sectionLabel: 'Pages',
    search: term => {
      const lowerTerm = term.toLowerCase();
      const matches = PAGES.map(page => ({
        ...page,
        label: transloco.translate(page.labelKey),
      })).filter(page => page.label.toLowerCase().includes(lowerTerm));
      return of(
        matches.map(page => ({
          id: page.path,
          label: page.label,
          onSelect: () => router.navigateByUrl(page.path),
        }))
      );
    },
  };
}
